import { render, staticRenderFns } from "./lamsRegLegalDoc.vue?vue&type=template&id=62c2840f&scoped=true&"
import script from "./lamsRegLegalDoc.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2840f",
  null
  
)

export default component.exports